var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"recent-month-power"},[_c('div',{staticStyle:{"width":"100%","cursor":"pointer"},on:{"click":_vm.handleNavGo}},[_c('pub-info-title',{attrs:{"title":'近30日储能充/放电量'}})],1),_c('div',{ref:"powerLine",staticClass:"power-line-chart"})])
}
var staticRenderFns = []

export { render, staticRenderFns }